<template>
	<div class="center1" v-if="isLoading">
		<div class="center2">
			<img style="width: 250px" src="/apicella-image.jpg" />
			<br />
			<div v-if="msec" style="width: 50vw">
				<el-progress :text-inside="true" :stroke-width="26" :percentage="percentage" />
			</div>
			<div v-if="msec == 0 || percentage == 100" class="lds-roller">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
	name: "loading-screen",
	data() {
		return {
			msec_interval: 500,
			msec_passed: 0,
			percentage: 0,
			interval: undefined
		}
	},
	computed: {
		...mapGetters({
			isLoading: "modules/loading",
			msec: "modules/msec",
			new_msec: "modules/new_msec"
		})
	},
	watch: {
		isLoading: function () {
			if (this.isLoading && this.msec) {
				if (this.interval == undefined) {
					this.msec_passed = 0
					this.percentage = 0
					this.interval = setInterval(this.updatePercentage, this.msec_interval)
				}
			} else if (this.interval != undefined) {
				clearInterval(this.interval)
				this.interval = undefined
			}
		},
		new_msec: function () {
			this.msec_passed = this.msec - this.new_msec
		}
	},
	methods: {
		updatePercentage() {
			this.msec_passed += this.msec_interval
			let perc = Math.ceil((this.msec_passed * 100) / this.msec)
			if (perc <= 100 && perc > this.percentage) this.percentage = perc
		}
	}
}
</script>
<style scoped>
.center1 {
	background: white;
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
}

.center2 {
	width: auto;
	padding: 20px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.lds-roller {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
}
.lds-roller div {
	animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	transform-origin: 40px 40px;
}
.lds-roller div:after {
	content: " ";
	display: block;
	position: absolute;
	width: 7px;
	height: 7px;
	border-radius: 50%;
	background: #000000;
	margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
	animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
	top: 63px;
	left: 63px;
}
.lds-roller div:nth-child(2) {
	animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
	top: 68px;
	left: 56px;
}
.lds-roller div:nth-child(3) {
	animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
	top: 71px;
	left: 48px;
}
.lds-roller div:nth-child(4) {
	animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
	top: 72px;
	left: 40px;
}
.lds-roller div:nth-child(5) {
	animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
	top: 71px;
	left: 32px;
}
.lds-roller div:nth-child(6) {
	animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
	top: 68px;
	left: 24px;
}
.lds-roller div:nth-child(7) {
	animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
	top: 63px;
	left: 17px;
}
.lds-roller div:nth-child(8) {
	animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
	top: 56px;
	left: 12px;
}
@keyframes lds-roller {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
